import './synthetic.component.ajscss';

import { timeParts } from '@commons/util/helper/time';
import { HypervisionState } from '@hypervision/hypervision-routing.module';
import { Domain } from '@hypervision/models/domain';
import { ISkillViewService } from '@hypervision/skill-view/skill-view.service';
import {
  forEach,
  IComponentController,
  IComponentOptions,
  IFilterService,
  IIntervalService,
  IQService,
  isArray,
  isDefined,
  isUndefined,
} from 'angular';
import { i18n } from 'i18next';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './synthetic.component.ajs.html';

class SyntheticCtrl extends DisplayDeprecatedComponent implements IComponentController {
  // Metric waiting to be displayed
  public metricBuffer: any[] = [];
  // Subscribed metrics
  public subscribedMetrics: any[] = [];
  // All the skills
  public skills: any[] = [];
  // Fill the index to ease access to the metric value
  // $scope.dataIndex['qdqsdqs-dsdsfsdf-xcvxcv@SUM_CSR_PRESENT_SKILL_NOW'].value
  public dataIndex = {};
  // The table data : An array of rows
  public dataSet: any[] = [];
  // Colums definition & visibility
  public cols: any[] = [];
  // Metric accessor (one for each media)
  public metricAccessor: any;
  private interval: any;

  constructor(
    private readonly skillHypervision: ISkillViewService,
    private readonly $i18next: i18n,
    private readonly SKILL_METRIC_NAMES,
    private readonly $interval: IIntervalService,
    private readonly $filter: IFilterService,
    private readonly $q: IQService
  ) {
    super();
    this.metricAccessor = 'name';
  }

  $onInit() {
    this.init();

    // Configure the method that update metric display with a setInterval
    this.interval = this.$interval(() => this.updateMetricsDisplay(), 1000);
  }

  $onDestroy() {
    if (isDefined(this.interval)) {
      this.$interval.cancel(this.interval);
    }
  }

  // called when a metric is updated. metricFullName like 'qsdqs-qsdqsd-sqdwcxvxc@SUM_CTT_NOT_PROCESSED_SKILL'
  onMetricUpdated(metricFullName, newValue) {
    if (isArray(metricFullName)) {
      forEach(metricFullName, metric => {
        let entity = metric.entityId;
        let indicator;
        let value = 0;
        let prop;
        for (prop in metric) {
          if (metric.hasOwnProperty(prop) && prop !== 'entityId') {
            indicator = prop;
            value = metric[prop];
          }
        }
        this.metricBuffer.push({ metricFullName: entity + '@' + indicator, value: value });
      });
    } else {
      this.metricBuffer.push({ metricFullName: metricFullName, value: newValue });
    }
  }

  // Refresh table and resubscribe to metrics
  refreshTable() {
    // Build table model
    this.skillHypervision.buildDataSetAndIndex(
      this.dataSet,
      this.dataIndex,
      this.skills,
      this.SKILL_METRIC_NAMES,
      this.metricAccessor,
      HypervisionState.SKILL_SYNTHETIC
    );
    // Build the columns info
    this.skillHypervision.buildColumnInfo(this.cols, this.SKILL_METRIC_NAMES, this.metricAccessor);
    this.skillHypervision.cleanSubscribeToMetrics(this.skills, this.SKILL_METRIC_NAMES, this.onMetricUpdated, this.metricAccessor);
  }

  // Format the value :)
  formatValue(indicatorName, value) {
    if (isUndefined(value)) {
      return '-';
    }
    if (isDefined(indicatorName)) {
      if (indicatorName.indexOf('RATE_') === 0) {
        return Math.round(100 * value) + ' %';
      } else if (indicatorName.indexOf('TA_') === 0) {
        let tp = timeParts(value);

        return this.$i18next.t('hypervision:indicator.avgProcessTimeFormat', {
          hour: tp[0],
          min: tp[1],
          second: tp[2],
        });
      }
    }
    return value;
  }

  // Initialisation
  init() {
    // Chargement des données
    this.skillHypervision
      .getDomainList()
      .then((domainList: Domain[]) => this.skillHypervision.getRootDomains(domainList))
      .then(rootDomains => {
        let allSkills: any[] = [];
        let queries: any[] = [];
        forEach(rootDomains, currentDomain => {
          currentDomain.root = true;
          queries.push(
            this.skillHypervision.getSkillList(currentDomain.uuid).then(data => {
              allSkills = allSkills.concat(data);
            })
          );
        });
        this.$q.all(queries).then(() => {
          // Set the skills
          this.skills = this.$filter('orderBy')(allSkills, 'name', false);

          // Refresh table (and subscriptions)
          this.refreshTable();
        });
      });
  }

  // Update table with new metrics
  updateMetricsDisplay() {
    forEach(this.metricBuffer.splice(0, this.metricBuffer.length), m => {
      if (isDefined(this.dataIndex) && isDefined(this.dataIndex[m.metricFullName])) {
        this.dataIndex[m.metricFullName].value = m.value;
      }
    });
  }
}

export class Synthetic implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['skillHypervision', '$i18next', 'SKILL_METRIC_NAMES', '$interval', '$filter', '$q', SyntheticCtrl];
}

export default 'skillViewSynthetic';
